import AttactFileIcons from '@/icons/AttactFileIcons'
import LoadIcons from '@/icons/LoadIcons'
import StarIcons from '@/icons/StarIcons'
import FaceIcons from '@/icons/FaceIcons'
import { TFunction } from 'i18next'
import { Ticket } from '../../types/response'
import TicketAttachments from './TicketAttachments'
import TicketFeedback from './TicketFeedback'
import TicketLog from './TicketLogs'
import TicketReports from './TicketReports'
import TicketProcessing from './TicketProcessing'

// Tabs without logs (for md+ screens where logs is in sidebar)
export const tabsWithoutLogs = (t: TFunction, ticket?: Ticket) => [
    {
        startIcon: <LoadIcons />,
        label: t('ticket-reports'),
        value: 'reports',
        component: <TicketReports />,
    },
    {
        startIcon: <FaceIcons />,
        label: 'Trao đổi',
        value: 'conversation',
        component: <TicketProcessing />,
    },
    {
        label: t('attachments'),
        value: 'attachments',
        startIcon: <AttactFileIcons />,
        component: <TicketAttachments />,
    },
    {
        label: t('feedback'),
        value: 'feedback',
        startIcon: <StarIcons />,
        component: (
            <TicketFeedback
                ticket_id={ticket?.ticket_id || 0}
                ticket_status={ticket?.ticket_status || ''}
            />
        ),
        hidden:
            !ticket ||
            ticket.ticket_type_group !== 'error_service' ||
            !['completed', 'closed'].includes(ticket.ticket_status),
    },
]

// All tabs including logs (for mobile screens)
export const tabs = (t: TFunction, ticket?: Ticket) => [
    ...tabsWithoutLogs(t, ticket),
    {
        label: t('logs'),
        value: 'logs',
        startIcon: <LoadIcons className="text-bg-primary" />,
        component: <TicketLog />,
    },
]
